import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Overview from "@/pages/Overview";
import Participants from "@/pages/Participants";
import ParticipantDetail from "@/pages/ParticipantDetail";
import CommitmentTracker from "@/pages/CommitmentTracker";
import EvidenceResults from "@/pages/EvidenceResults";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111116",
            border: "1px solid #24242c",
            color: "#f5f0e8",
          },
        }}
      />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Overview />} />
          <Route path="/participants" element={<Participants />} />
          <Route path="/participants/:id" element={<ParticipantDetail />} />
          <Route path="/commitments" element={<CommitmentTracker />} />
          <Route path="/evidence" element={<EvidenceResults />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
